export default "__VITE_ASSET__BxqhhRYG__"